/* eslint-disable*/
$(function() {
    // card animation
    var greetingContainer = $('.xmas-card-animation .greeting-container');
    var cardContainer = $('.xmas-card-animation .card-container');
    var cardActionConsole = $('.xmas-card-animation .card-container .action');
    var card = $('.xmas-card-animation .card-container .card');
    var footnote = $('.xmas-card-animation .card-container .footnote');
    var restartSelector = $('.js-animation-restart');
    var rotateSelector = $('.js-animation-rotate');
    var isRotated = false;
    var isRotatedClass = 'card--is-rotated';

    //var delayAnimationCard = 17;
    var delayAnimationCard = 10;
    if(jQuery('.customer-card-2021').length > 0 ) {
        delayAnimationCard = 7;
    }

    TweenLite.set(greetingContainer, {opacity: 0});
    var tl = new TimelineLite();
    tl.add(TweenLite.to(greetingContainer, 0.5, {opacity: 1}));
    tl.add(TweenLite.to(greetingContainer, 0.5, {opacity: 0}), "+=4");
    tl.add(TweenLite.to(cardContainer, 1.25, {opacity: 1, right: '50%', onStart:startAnime}));
    tl.add(TweenLite.fromTo(card, 1, {rotationY: 0}, {rotationY: -180, onComplete: rotateState}), "+="+delayAnimationCard);
    tl.add(TweenLite.to(cardActionConsole, 0.5, {opacity: 1}), '-=0.5');
    tl.add(TweenLite.to(footnote, 0.5, {opacity: 1}));

    function startAnime (){
        var src = jQuery('.canvas-wrapper iframe').attr('src');
        jQuery('.card__front .canvas-wrapper iframe').attr('src',src);
    }

    function rotateState () {
        isRotated = true;
        card.addClass(isRotatedClass);
    }

    restartSelector.on('click', function() {
        card.removeClass(isRotatedClass);
        tl.restart();
        // restart animation
        setTimeout(function(){
            startAnime ();
        }, 5000);
    });

    rotateSelector.on('click', function() {
        if (isRotated) {
            TweenLite.fromTo(card, 1, {rotationY: -180}, {rotationY: 0});
            isRotated = false;
            setTimeout(function() {
                card.removeClass(isRotatedClass);
            }, 500);
        } else {
            TweenLite.fromTo(card, 1, {rotationY: 0}, {rotationY: -180});
            isRotated = true;
            setTimeout(function() {
                card.addClass(isRotatedClass);
            }, 500);
        }
    });

    // new layout 2023
    var slider = jQuery('#A1-Xmas-slider-2023');
    function initXmas2023(){
        slider.slick({
            infinite: true,
            slidesToShow: 2,
            arrows: false,
            dots: false,
            variableWidth: false,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        dots: true,
                        slidesToShow: 1
                    }
                }
            ]
        });
    };

    jQuery(window).on('load resize', function() {
        var viewportWidth = jQuery(window).width();

        if (viewportWidth >= 768) {
            if($('#A1-Xmas-slider-2023').hasClass('slick-initialized')) {
                slider.slick('unslick');
            }
        } else {
            var slides = jQuery('.canvas-wrapper').length;
            if(slides > 1){
                if(!$('#A1-Xmas-slider-2023').hasClass('slick-initialized')) {
                    initXmas2023();
                }
            }
        }
    });

    var cardCheck = jQuery('#A1-Xmas-slider-2023').find('.ms-box.checked').attr('data-cardcheck');
    jQuery('#cardLink').attr('href', 'form.php?app_locale=' + getQueryVariable('app_locale') + '&card=' + cardCheck);

    jQuery('#A1-Xmas-slider-2023 .ms-box').on('click',function(){
        if(!jQuery(this).hasClass('checked')){
            jQuery('.ms-box').each(function(){
                jQuery(this).removeClass('checked');
            });
            jQuery(this).addClass('checked');
            cardCheck = jQuery('#A1-Xmas-slider-2023').find('.ms-box.checked').attr('data-cardcheck');
            jQuery('#cardLink').attr('href', 'form.php?app_locale=' + getQueryVariable('app_locale') + '&card=' + cardCheck);
            jQuery('.xmas-card-music-play').each(function(){
                jQuery(this).removeClass('play-music');
                jQuery('#xmas-card-music').get(0).currentTime = 76;
                jQuery('#xmas-card-music').get(0).pause();
            })
        }
    });

    // re init the label placeholder position after new inputs placed
    function selectlabelInit() {
        jQuery('.js-styled-select').on('change', function() {
            toggleIsEmpty(jQuery(this));
        });
    }

    function inputlabelInit(){
        jQuery('.xmas-card-form_field_c_wrapper.dynamic input').each(function() {
            jQuery(this).on('focusout', function(){
                var el = jQuery(this);
                if (el.val() === '') {
                    el.closest('.input-wrapper').addClass('is-empty');
                } else {
                    el.closest('.input-wrapper').removeClass('is-empty');
                }
            });
        });
    }

    // plus-minus email adresses
    jQuery('.xmas-card-form_field_c_wrapper:first').addClass('first');
    var rowCounter = 1;
    function cloneRow(){
        let row = row = '<div class="row xmas-card-form_field_c_wrapper dynamic"> <div class="col-12 col-md-3"> <div class="input-wrapper input-wrapper-select is-empty"> <select id="to_salutation_' + rowCounter + '" class="js-styled-select" title="title-to" name="salutation[]" multiple="false" required> <option>Liebe</option><option>Lieber</option><option>Sehr geehrter</option><option>Sehr geehrte</option>  </select> <label for="to_salutation_' + rowCounter + '">Anrede des Empfängers</label> </div></div><div class="col-12 col-md-4"> <div class="input-wrapper is-empty"> <input type="text" id="to_name_' + rowCounter + '" name="to_name[]" value="" required autocomplete="off" class="is-empty"/> <label for="to_name_' + rowCounter + '">Name des Empfängers</label> </div></div><div class="col-12 col-md-4"> <div class="input-wrapper is-empty"> <input type="email" id="to_email_' + rowCounter + '" name="to_email[]" value="" required autocomplete="off" class="is-empty"/> <label for="to_email_' + rowCounter + '">E-Mail des Empfängers</label> </div></div><div class="col-12 col-md-1 xmas-card-form__plus-minus-icons"> <div class="xmas-card-form__plus">+</div><div class="xmas-card-form__minus">-</div></div></div>';
        if (getQueryVariable('app_locale') === 'en_US') {
            row = '<div class="row xmas-card-form_field_c_wrapper dynamic"> <input type="hidden" name="salutation[]" value="Dear" required> <div class="col-12 col-md-6"> <div class="input-wrapper is-empty"> <input type="text" id="to_name_' + rowCounter + '" name="to_name[]" value="" required autocomplete="off" class="is-empty"/> <label for="to_name_' + rowCounter + '">Recipient name</label> </div></div><div class="col-12 col-md-5"> <div class="input-wrapper is-empty"> <input type="email" id="to_email_' + rowCounter + '" name="to_email[]" value="" required autocomplete="off" class="is-empty"/> <label for="to_email_' + rowCounter + '">Recipient email</label> </div></div><div class="col-12 col-md-1 xmas-card-form__plus-minus-icons"> <div class="xmas-card-form__plus">+</div><div class="xmas-card-form__minus">-</div></div></div>';
        }
        jQuery(row).insertAfter('.xmas-card-form_field_c_wrapper:last');

        // init virtual select
        initVirtualSelect('#to_salutation_' + rowCounter);

        rowCounter ++;
    }

    function removeRow(button){
        var row = button.parent().parent('.xmas-card-form_field_c_wrapper');
        row.remove();
    }

    function getQueryVariable(variable) {
        const query = window.location.search.substring(1);
        const vars = query.split("&");
        for (let i = 0; i < vars.length; i++) {
            let pair = vars[i].split("=");
            if (pair[0] == variable) {
                return pair[1];
            }
        }
    }

    jQuery('body').on('click', '.xmas-card-form__plus', function(){
        cloneRow();
        inputlabelInit();
        selectlabelInit();
    });

    jQuery('body').on('click', '.xmas-card-form__minus', function(){
        var btn = jQuery(this);
        removeRow(btn);
    });

    // music handler
    jQuery('.xmas-card-music-play').on('click', function(){
        if(!jQuery(this).hasClass('play-music')){
            jQuery('#xmas-card-music').get(0).currentTime = 76;
            jQuery('#xmas-card-music').get(0).play();
            jQuery(this).addClass('play-music');
            jQuery('.card__back .xmas-card-music-play, .card__front .xmas-card-music-play').addClass('play-music');
        } else {
            jQuery('#xmas-card-music').get(0).pause();
            jQuery(this).removeClass('play-music');
            jQuery('.card__back .xmas-card-music-play, .card__front .xmas-card-music-play').removeClass('play-music');
        }
    });

    jQuery('.click-select').on('click', function(){
        var src = jQuery(this).next().find('iframe').attr('src');
        jQuery(this).next().find('iframe').attr('src',src);
    })

    // init virtual select - fresh design
    function initVirtualSelect (element) {
        VirtualSelect.init({
            ele: element,
            showDropboxAsPopup: 'false',
            hideClearButton: true,
            placeholder: ' ',
            noOptionsText: 'Keine Optionen verfügbar',
            noSearchResultsText: 'Keine Ergebnisse gefunden',
            selectAllText: 'Alle auswählen',
            searchPlaceholderText: 'Suchen',
            optionsSelectedText: 'Optionen ausgewählt',
            optionSelectedText: 'Option ausgewählt',
            allOptionsSelectedText: 'Alle ausgewählt',
            clearButtonText: 'Entfernen',
            moreText: 'Mehr ...'
        });
    }

    function isEmpty (inputValue) {
        if(!inputValue.replace(/\s+/, '').length) {
            return true;
        }
        return false;
    }

    function toggleIsEmpty (inputField) {
        var inputValue = inputField.value ? inputField.value : inputField.find('input').val();
        if(isEmpty(inputValue) && inputField.closest('.input-wrapper') !== null) {
            inputField.closest('.input-wrapper').addClass('is-empty');
        } else if(inputField.closest('.input-wrapper') !== null) {
            inputField.closest('.input-wrapper').removeClass('is-empty');
        }
    }

    initVirtualSelect('.js-styled-select');

    jQuery('.js-styled-select').each(function() {
        toggleIsEmpty(jQuery(this));
    });

    jQuery('.js-styled-select').on('change', function() {
        toggleIsEmpty(jQuery(this));
    });
});
